import "./css/app.scss";
import accordian from "./ts/accordian";
import calcBoxPrice from "./ts/calcBoxPrice";
import cartValidation from "./ts/cartValidation";
import clearFilters from "./ts/clearFilters";
import dropdown from "./ts/dropdowns";
import filterGrouping from "./ts/filterGrouping";
import mobMenu from "./ts/mobMenu";
import mulltyAdd from "./ts/mulltyAdd";
import nestedAccordian from "./ts/nestedAccordian";
import "./ts/neto.js";
import readMore from "./ts/readmore";
import sowHideBloks from "./ts/showHideBloks";
import sliders from "./ts/slider";
import stickyHeader from "./ts/stickyHeader";
import stringReplace from "./ts/stringReplace";
import { addEvent, appHeight, heightChange } from "./ts/utils";

addEvent()
appHeight()
heightChange();
filterGrouping.init()
accordian.init();
sliders.init();
sowHideBloks.init();
nestedAccordian.init();
stickyHeader.init();
dropdown.init();
readMore.init()
mobMenu.init()
mulltyAdd.init()
clearFilters.init()
calcBoxPrice.init()
stringReplace.init()
cartValidation.init()